
define('jsx!components/modal/share/share-direct-teacher',[
	"underscore",
	"jquery",
	"react",
	"shared/user"
], function(_, $, React, User) {
	return React.createClass({
		displayName: "ShareCode",
		getInitialState: function() {
			return {
				loading: true,
				sharedWith: {},
				canBeSharedWith: {},
				selectedSection: "default",
				selectedUsers: {}
			};
		},
		hide: function(e) {
			this.props.hideModal(e);
		},
		pullCurrentShareState: function() {
			var self = this;
			this.setState({
				loading: true
			});
			window.api.request("share", this.props.stores.buncee.getBuncee().guid, {entity_type: 'buncee'}).execute().done(function(response) {
				var canBeSharedWith = response.data.can_be_shared_with;
				
				var filteredSections = _.pick(canBeSharedWith.section, function(section) {
					return (section.students.length + section.teachers.length) > 1
				});
				canBeSharedWith.section = filteredSections;
				
				var selectedUsers = {};
				_.each(canBeSharedWith.section, function(section) {
					selectedUsers[section.guid] = []
				});	
				response.data.shared_with.forEach(function(sharedEntity) {
					if(!sharedEntity.section_guid in canBeSharedWith.section) {
						return;
					}
					if(sharedEntity.user_guid === null && sharedEntity.group_guid === null) {
						// Shared with the whole section so add all teachers
						var section = canBeSharedWith.section[sharedEntity.section_guid];
						if(!section) {
							return;
						}
						var teachers = section.teachers.slice(0);
						teachers.splice(teachers.indexOf(User.getGUID()), 1);
						selectedUsers[section.guid] = section.students.concat(teachers);
					} else if(sharedEntity.user_guid === null) {
						// TODO: Shared with group not implemented
					} else {
						selectedUsers[sharedEntity.section_guid].push(sharedEntity.user_guid);
					}
				});


				self.setState({
					sharedWith: response.data.shared_with,
					canBeSharedWith: canBeSharedWith,
					selectedUsers: selectedUsers,
					loading: false
				}, function() {
					self.selectSection(self.state.selectedSection);
				})
			});
		},
		startAdding: function() {
			this.setState({
				adding: true
			})
		},
		save: function() {
			var self = this;
			var recipients = [];
			for(sectionGuid in this.state.selectedUsers) {
				var section = this.state.canBeSharedWith.section[sectionGuid];
				var students = this.state.canBeSharedWith.section[sectionGuid].students;
				var teachers = this.state.canBeSharedWith.section[sectionGuid].teachers.slice(0);
				teachers.splice(teachers.indexOf(User.getGUID()), 1);
				if(this.state.selectedUsers[sectionGuid].length === students.concat(teachers).length) {
					recipients.push({
						section_guid: section.guid
					});
				} else {
					this.state.selectedUsers[sectionGuid].forEach(function(guid) {
						recipients.push({
							user_guid:guid,
							section_guid: section.guid
						});
					})
				}
			}

			this.setState({
				loading: true
			});

			window.api.request("share").create({
				"entity_type": "buncee",
				"entity_guid": this.props.stores.buncee.getBuncee().guid,
				recipients: recipients
			}).done(function(response) {
				self.pullCurrentShareState();
				self.props.actions.toast(".buncee-modal-action", "Shared");
			});
		},
		componentDidMount: function() {
			this.pullCurrentShareState();
		},
		componentDidUpdate: function(prevProps, prevState) {
			if(_.keys(prevState.canBeSharedWith).length === 0 && _.keys(this.state.canBeSharedWith).length !== 0 && _.keys(this.state.canBeSharedWith.section).length >= 1) {
				var sortedSections = _.sortBy(_.values(this.state.canBeSharedWith.section), function(section) {
					return section.display_name
				});
				this.selectSection(sortedSections[0].guid);
			}
		},
		selectAllUsers: function() {
			var section = this.state.canBeSharedWith.section[this.state.selectedSection];
			var teachers = section.teachers.slice(0);
			teachers.splice(teachers.indexOf(User.getGUID()), 1);

			var selectedUsers = this.state.selectedUsers;
			selectedUsers[section.guid] = section.students.concat(teachers);
			this.setState({
				selectedUsers: selectedUsers
			});
		},
		deselectAllUsers: function() {
			var section = this.state.canBeSharedWith.section[this.state.selectedSection];
			var selectedUsers = this.state.selectedUsers;
			selectedUsers[section.guid] = [];
			this.setState({
				"selectedUsers": selectedUsers
			});
		},	
		handleSelectedSectionChange: function(e) {
			var sectionGUID = e.target.value;
			this.selectSection(sectionGUID);
		},
		selectSection: function(sectionGUID) {
			this.setState({
				selectedSection: sectionGUID
			});
		},
		handleUserCheckboxChange: function(e) {
			var checked = e.target.checked;
			var userGUID = e.target.getAttribute('id');

			if(checked) {
				var selectedUsers = this.state.selectedUsers;
				var selectedUsersForCurrentSection = selectedUsers[this.state.selectedSection].slice(0).concat([userGUID]);
				selectedUsers[this.state.selectedSection] = selectedUsersForCurrentSection;
				this.setState({
					selectedUsers: selectedUsers
				})
			} else {
				var selectedUsers = this.state.selectedUsers;
				var selectedUsersForCurrentSection = selectedUsers[this.state.selectedSection].slice(0);
				selectedUsersForCurrentSection.splice(selectedUsersForCurrentSection.indexOf(userGUID), 1);
				selectedUsers[this.state.selectedSection] = selectedUsersForCurrentSection

				this.setState({
					selectedUsers: selectedUsers
				});
			}
		},
		userCheckbox: function(user) {
			var disabled = false;
			var isSelected = false;
			if(!user) {
				return;
			}  else if(this.state.selectedUsers[this.state.selectedSection].indexOf(user.guid) > -1) {
				isSelected = true;
			}

			return (
				React.createElement("div", {key: user.guid, className: "md-checkbox col-sm-6"}, 
					React.createElement("input", {id: user.guid, type: "checkbox", checked: isSelected, disabled: disabled, onChange: this.handleUserCheckboxChange}), 
					React.createElement("label", {htmlFor: user.guid}, user.name)
				)
			)
		},
		renderSelectOptions: function() {
			var self = this;
			if(this.state.selectedSection === "default") {
				return null;
			}
			var students = this.state.canBeSharedWith.section[this.state.selectedSection].students;
			var teachers = this.state.canBeSharedWith.section[this.state.selectedSection].teachers.slice(0);

			teachers.splice(teachers.indexOf(User.getGUID()), 1);

			teachers = _.sortBy(_.values(teachers), function(guid) {
				return self.state.canBeSharedWith.user[guid].name;
			});

			students = _.sortBy(_.values(students), function(guid) {
				return self.state.canBeSharedWith.user[guid].name;
			});
			return (
				React.createElement("div", {className: "row users-lists-wrapper"}, 
					React.createElement("span", {className: "button-type-2 " + (students.concat(teachers).length === this.state.selectedUsers[this.state.selectedSection].length ? "active" : ""), onClick: this.selectAllUsers}, "Select All"), 
					React.createElement("span", {className: "button-type-2 red " + (this.state.selectedUsers[this.state.selectedSection].length === 0 ? "active" : ""), onClick: this.deselectAllUsers}, "Deselect All"), 
					teachers.length > 0 ? (React.createElement("div", {className: "user-list"}, 
						React.createElement("h4", null, "Teachers"), 
						
							teachers.map(function(teacherGUID) {
								var teacher = self.state.canBeSharedWith.user[teacherGUID];
								return (self.userCheckbox(teacher));
							})
						
					)) : null, 
					students.length > 0 ? (React.createElement("div", {className: "user-list"}, 
						React.createElement("h4", null, "Students"), 
						
							students.map(function(studentGUID) {
								var student = self.state.canBeSharedWith.user[studentGUID];
								return (self.userCheckbox(student))
							})
						
					)) : null
				)
			)
		},
		renderShareSelect: function() {
			// var sectionsAvailable = _.omit(this.state.canBeSharedWith.section, this.state.sharedWith.section);
			// if(sectionsAvailable.length === 0 || this.state.adding === false) {
			// 	return null;
			// }
			sortedSections = _.sortBy(_.values(this.state.canBeSharedWith.section), function(section) {
				return section.display_name
			});
			return (
				React.createElement("div", {className: "form-group"}, 
					React.createElement("label", {htmlFor: "sectionsSelect", className: "col-sm-3 col-md-3 col-lg-3 control-label"}, "Share with"), 
					React.createElement("div", {className: "col-sm-9 col-md-9 col-lg-9"}, 
						React.createElement("select", {id: "sectionsSelect", name: "teachers", className: "form-control", value: this.state.selectedSection, 
							onChange: this.handleSelectedSectionChange}, 
							React.createElement("option", {value: "default", disabled: true}, "Add Sections"), 
							
								_.map(sortedSections, function(section) {
									return (
										React.createElement("option", {key: section.guid, value: section.guid}, section.display_name)
									);
								})
							
						), 
						this.renderSelectOptions()
					)
				)
			)
		},
		render: function() {
			var self = this;
			console.log(this.state);
			if(this.state.loading) {
				return (React.createElement("div", {className: "direct-options teacher"}, React.createElement("div", {className: "loader"}
				)))
			} else {
				// debugger;
				return (
					React.createElement("div", {className: "direct-options teacher"}, 
						React.createElement("div", {className: "loader", style: {display: "none"}}
						), 
						this.renderShareSelect(), 

						React.createElement("div", {className: "buncee-modal-buttons col-sm-12"}, 
							React.createElement("button", {className: "modal-button", onClick: this.save, onTouchEnd: this.save}, "SHARE"), 
							React.createElement("button", {className: "modal-button button-red", onClick: this.hide, onTouchEnd: this.hide}, "CLOSE")
						)
					)
				);
			}
		}
	});
});
